enum BiteLogElavonEvent {
  None = 0,
  TerminalDisconnected = 1,
  UpdateIdleTextError = 2,
  SaleTransaction = 3,
  SaleTransactionError = 4,
  TerminalConnected = 5,
  NoResponseReceived = 6,
}

export { BiteLogElavonEvent };
